import React from 'react';
import { Form, Formik } from 'formik';
import { SelectAppointmentType } from './SelectAppointmentType';
import { PropertyAddressSection } from './PropertyAddressSection';
import { NotesSection } from './NotesSection';
import { DateTimeSection } from './DateTimeSection';
import { SigningInfoSection } from './SigningInfoSection';
import { WizardFormProps } from '../../shared/WizardFormProps';
import { SelectCorrectionReasons } from './SelectCorrectionReasons';
import { eSigningMethod } from '../../../../../../types/signingAppointment/eSigningMethod';
import useBuildInitialFormData from './hooks/useBuildInitialFormData';
import { IDetailsFormData } from './types/IDetailsFormData';
import useDetailsValidationSchema from './hooks/useDetailsValidationSchema';

export const DetailsForm: React.FC<WizardFormProps> = ({
  advance,
  isCorrection = false,
  updatedWizardFormData,
  setUpdatedWizardFormData,
  children,
}) => {
  const initialFormData = useBuildInitialFormData(updatedWizardFormData);
  const validationSchema = useDetailsValidationSchema(isCorrection);
  return (
    <Formik
      initialValues={initialFormData}
      validationSchema={validationSchema}
      onSubmit={(values: IDetailsFormData) => {
        const isSignatureSyncAppointment =
          values.signingMethod === eSigningMethod.notaryOnly && values.isSignatureSyncAppointment;
        setUpdatedWizardFormData((prevState) => ({
          ...prevState,
          ...values,
          isSignatureSyncAppointment,
        }));
        advance();
      }}
      validateOnMount
      enableReinitialize
    >
      <Form>
        <div className="flex flex-row gap-4">
          <SelectAppointmentType isCorrection={isCorrection} />
          <SelectCorrectionReasons isCorrection={isCorrection} />
        </div>
        <SigningInfoSection />
        <DateTimeSection />
        <PropertyAddressSection />
        <NotesSection />
        {children}
      </Form>
    </Formik>
  );
};
